/* Decorative interactions only. Rental and availability logic remains independent. */
(()=>{
  function mount(){
    const nav=document.querySelector('.navlinks'),panda=document.querySelector('#panda-static-entry');
    if(nav&&panda)nav.appendChild(panda);
    const gallery=document.querySelector('.gallery');
    if(gallery&&getComputedStyle(gallery).display==='none')gallery.closest('section')?.setAttribute('hidden','');
    document.querySelectorAll('.size-choice,.scale>div').forEach(card=>{
      if(card.querySelector('.mg-mini-scene'))return;
      const scene=document.createElement('div');
      scene.className='mg-mini-scene';scene.setAttribute('aria-hidden','true');
      scene.innerHTML='<div class="mg-mini-van"><div class="mg-mini-front"></div><div class="mg-mini-top"></div><div class="mg-mini-side"></div><div class="mg-mini-wheel a"></div><div class="mg-mini-wheel b"></div></div>';
      card.querySelector('em')?.insertAdjacentElement('afterend',scene);
    });
    const fine=matchMedia('(hover:hover) and (pointer:fine)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
    document.querySelectorAll('.fleet .card').forEach(card=>{
      let frame=0;
      const reset=()=>{cancelAnimationFrame(frame);card.style.removeProperty('--rx');card.style.removeProperty('--ry');};
      card.addEventListener('pointermove',e=>{
        if(!fine.matches||reduced.matches)return;
        cancelAnimationFrame(frame);
        frame=requestAnimationFrame(()=>{const r=card.getBoundingClientRect();card.style.setProperty('--rx',`${(0.5-(e.clientY-r.top)/r.height)*3}deg`);card.style.setProperty('--ry',`${((e.clientX-r.left)/r.width-0.5)*4}deg`);});
      },{passive:true});
      card.addEventListener('pointerleave',reset);card.addEventListener('pointercancel',reset);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();
